import React, { useState } from 'react';
import './DomainNational.css';

const DomainNational = () => {
  const [domainName, setDomainName] = useState('');
  const [selectedTld, setSelectedTld] = useState('.ir');

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const nationalTlds = [
    { tld: '.ir', price: '۵۰,۰۰۰', description: 'محبوب‌ترین دامنه ملی ایران', popular: true },
    { tld: '.co.ir', price: '۴۰,۰۰۰', description: 'مناسب برای شرکت‌ها و سازمان‌ها' },
    { tld: '.ac.ir', price: '۴۵,۰۰۰', description: 'مناسب برای مراکز علمی و دانشگاهی' },
    { tld: '.sch.ir', price: '۴۰,۰۰۰', description: 'مناسب برای مدارس و مراکز آموزشی' },
    { tld: '.org.ir', price: '۴۵,۰۰۰', description: 'مناسب برای سازمان‌های غیرانتفاعی' },
    { tld: '.net.ir', price: '۴۲,۰۰۰', description: 'مناسب برای شرکت‌های شبکه و فناوری' },
  ];

  const handleSearch = () => {
    if (!domainName.trim()) {
      alert('لطفاً نام دامنه را وارد کنید');
      return;
    }
    let fullDomain = domainName.trim();
    if (!fullDomain.includes('.')) {
      fullDomain += selectedTld;
    }
    window.open('https://hub.afracell.com/cart.php?a=add&domain=register&query=' + encodeURIComponent(fullDomain), '_blank');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const selectTld = (tld) => {
    setSelectedTld(tld);
  };

  const features = [
    {
      icon: '🇮🇷',
      title: 'هویت ایرانی معتبر',
      desc: 'دامنه‌های ملی ایران با پسوند .ir و سایر پسوندهای مرتبط، هویت ایرانی کسب‌وکار شما را در فضای آنلاین تقویت می‌کنند و اعتماد کاربران ایرانی را جلب می‌نمایند.',
    },
    {
      icon: '📋',
      title: 'تأیید هویت آنلاین و سریع',
      desc: 'فرآیند تأیید هویت برای ثبت دامنه ملی به صورت کاملاً آنلاین انجام می‌شود و نیازی به مراجعه حضوری نیست. این فرآیند معمولاً کمتر از ۲۴ ساعت زمان می‌برد.',
    },
    {
      icon: '⚡',
      title: 'فعال‌سازی فوری پس از تأیید',
      desc: 'پس از تأیید هویت، دامنه شما بلافاصله فعال می‌شود و می‌توانید از آن برای راه‌اندازی وب‌سایت، ایمیل سازمانی و سایر خدمات استفاده کنید.',
    },
    {
      icon: '🛡️',
      title: 'مدیریت DNS پیشرفته و رایگان',
      desc: 'پنل مدیریت DNS پیشرفته با امکان تغییر رکوردهای A، CNAME، MX، TXT و SRV به صورت رایگان در اختیار شما قرار می‌گیرد.',
    },
  ];

  const requirements = [
    'داشتن مدارک شناسایی معتبر (کارت ملی یا شناسنامه) برای افراد حقیقی',
    'داشتن مدارک ثبت شرکت یا جواز کسب برای افراد حقوقی',
    'تطابق نام دامنه با نام شخص حقیقی یا نام شرکت/کسب‌وکار',
    'تأیید هویت از طریق سامانه مرکز ثبت دامنه ایران (IRNIC)',
    'پرداخت هزینه ثبت دامنه به صورت آنلاین از طریق درگاه امن',
  ];

  const faqs = [
    {
      q: 'ثبت دامنه ملی ایران چه مدارکی نیاز دارد؟',
      a: 'برای ثبت دامنه ملی ایران، افراد حقیقی باید کارت ملی یا شناسنامه معتبر ارائه دهند. افراد حقوقی نیز باید مدارک ثبت شرکت یا جواز کسب معتبر داشته باشند. نام دامنه باید با نام شخص حقیقی یا نام شرکت تطابق داشته باشد. تمامی مدارک به صورت آنلاین از طریق سامانه مرکز ثبت دامنه ایران (IRNIC) بررسی و تأیید می‌شوند.',
    },
    {
      q: 'چقدر طول می‌کشد تا دامنه ملی من فعال شود؟',
      a: 'پس از ثبت درخواست و ارسال مدارک، فرآیند تأیید هویت معمولاً بین ۲۴ تا ۴۸ ساعت طول می‌کشد. در صورت کامل بودن مدارک و تطابق آنها با نام دامنه، تأییدیه صادر شده و دامنه شما بلافاصله فعال می‌شود. در برخی موارد نادر، این فرآیند ممکن است تا ۷۲ ساعت نیز ادامه یابد.',
    },
    {
      q: 'آیا می‌توانم دامنه ملی خود را به شخص دیگری منتقل کنم؟',
      a: 'بله، انتقال دامنه ملی بین اشخاص حقیقی یا حقوقی امکان‌پذیر است. برای این کار باید درخواست انتقال را از طریق پنل مدیریت دامنه ثبت کنید و مدارک جدید برای تأیید هویت ارائه دهید. فرآیند انتقال معمولاً ۲۴ تا ۴۸ ساعت طول می‌کشد و هزینه خاصی برای آن دریافت نمی‌شود.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>ثبت دامنه ملی ایران | خرید دامنه .ir با بهترین قیمت | افرسل</h1>
        <p>ثبت دامنه ملی ایران با پسوندهای .ir، .co.ir، .ac.ir، .sch.ir، .org.ir و .net.ir. قیمت رقابتی، تأیید هویت آنلاین، فعال‌سازی سریع و پشتیبانی ۲۴ ساعته. دامنه ملی مناسب برای کسب‌وکارهای ایرانی، سازمان‌ها و افراد حقیقی.</p>
        <meta name="description" content="ثبت دامنه ملی ایران با بهترین قیمت در افرسل. خرید دامنه .ir، .co.ir، .ac.ir و سایر پسوندهای ملی. تأیید هویت آنلاین، فعال‌سازی سریع، مدیریت DNS پیشرفته و پشتیبانی ۲۴/۷." />
      </div>

      <section className="national-hero">
        <div className="national-hero-bg"></div>
        <div className="wrap">
          <div className="national-hero-content">
            <div className="national-badge">
              <span className="pulse-dot"></span>
              🇮🇷 دامنه ملی ایران
            </div>
            <h1 className="national-hero-title">
              ثبت دامنه <em>ملی ایران</em>
            </h1>
            <p className="national-hero-desc">
              دامنه ملی ایران با پسوند .ir و سایر پسوندهای مرتبط، هویت ایرانی کسب‌وکار شما را در فضای آنلاین تقویت می‌کند. 
              با ثبت دامنه ملی، اعتماد کاربران ایرانی را جلب کرده و در نتایج جستجوی گوگل ایران جایگاه بهتری خواهید داشت. 
              فرآیند ثبت ساده، تأیید هویت آنلاین و فعال‌سازی سریع از مزایای ثبت دامنه ملی در افرسل است.
            </p>
            <div className="national-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۶+</span>
                <span className="stat-label">پسوند ملی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴س</span>
                <span className="stat-label">زمان فعال‌سازی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰٪</span>
                <span className="stat-label">تأیید هویت آنلاین</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="national-search">
        <div className="wrap">
          <div className="national-search-box">
            <h3 className="national-search-title">دامنه ملی مورد نظر خود را جستجو کنید</h3>
            <div className="national-search-input">
              <input
                type="text"
                className="national-input-main"
                placeholder="مثال: mybusiness"
                value={domainName}
                onChange={(e) => setDomainName(e.target.value)}
                onKeyDown={handleKeyDown}
                dir="ltr"
              />
              <button className="national-search-btn" onClick={handleSearch}>
                جستجوی دامنه
              </button>
            </div>
            <div className="national-tld-hint">
              <span>پسوندهای محبوب: </span>
              {nationalTlds.map((tld, i) => (
                <button
                  key={i}
                  className={`national-tld-btn ${selectedTld === tld.tld ? 'active' : ''}`}
                  onClick={() => selectTld(tld.tld)}
                >
                  {tld.tld}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="national-tlds">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پسوندهای ملی ایران</span>
            <h2 className="sec-h">دامنه‌های <em>ملی ایران</em></h2>
            <p className="sec-p">ثبت دامنه‌های ملی ایران با قیمت رقابتی و پشتیبانی کامل. انتخاب از بین پسوندهای مختلف برای هر نوع کسب‌وکار و سازمان.</p>
          </div>
          <div className="national-tlds-grid">
            {nationalTlds.map((tld, i) => (
              <div key={i} className={`national-tld-card ${tld.popular ? 'popular' : ''}`}>
                {tld.popular && <span className="national-tld-popular">پرفروش</span>}
                <div className="national-tld-name">{tld.tld}</div>
                <div className="national-tld-price">{tld.price} تومان</div>
                <div className="national-tld-desc">{tld.description}</div>
                <button className="national-tld-btn-order" onClick={() => {
                  setSelectedTld(tld.tld);
                  document.querySelector('.national-input-main').focus();
                }}>
                  ثبت کنید
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="national-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای دامنه ملی</span>
            <h2 className="sec-h">چرا <em>دامنه ملی</em> ثبت کنیم؟</h2>
            <p className="sec-p">دامنه ملی ایران با هویت ایرانی، اعتماد کاربران را جلب کرده و برای کسب‌وکارهای داخلی گزینه‌ای ایده‌آل است. ثبت دامنه ملی در افرسل با بهترین شرایط انجام می‌شود.</p>
          </div>
          <div className="national-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="national-feature-card">
                <span className="national-feature-icon">{feature.icon}</span>
                <h3 className="national-feature-title">{feature.title}</h3>
                <p className="national-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="national-requirements">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">شرایط ثبت دامنه ملی</span>
            <h2 className="sec-h">مدارک و <em>شرایط</em> ثبت دامنه ملی</h2>
            <p className="sec-p">برای ثبت دامنه ملی ایران، باید مدارک مشخصی ارائه دهید و شرایط زیر را داشته باشید.</p>
          </div>
          <div className="national-requirements-grid">
            {requirements.map((req, i) => (
              <div key={i} className="national-requirement-item">
                <span className="national-req-number">{String(i + 1).padStart(2, '0')}</span>
                <span className="national-req-text">{req}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="national-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
            <p className="sec-p">پاسخ سوالات رایج درباره ثبت دامنه ملی ایران را در این بخش مشاهده کنید.</p>
          </div>
          <div className="national-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="national-faq-item">
                <div className="national-faq-q">{faq.q}</div>
                <div className="national-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="national-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              دامنه <em>ملی</em> خود را ثبت کنید
            </h2>
            <p className="cta-desc">
              با ثبت دامنه ملی، هویت ایرانی خود را در فضای آنلاین بسازید. 
              فرآیند ثبت ساده، تأیید هویت آنلاین و پشتیبانی ۲۴ ساعته در کنار شماست.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => document.querySelector('.national-input-main')?.focus()}>
                جستجوی دامنه
              </button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>
                مشاوره رایگان
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DomainNational;
